module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-avocat.14a496db.jpg";